<template>
  <div ref="milestoneMapChart" :style="style"></div>
</template>

<script>
  import * as echarts from 'echarts';
  import worldJson from 'echarts-map/json/world.json';
  import * as countries from '../../store/countries';

  export default {
    name: 'MilestoneWorldMap',
    props: ['milestoneMapChartData', 'height'],
    data() {
      return {
        data: [],
        myChart: {},
        style: '',
        mapCountriesNames: countries.mapNames,
      };
    },
    created() {
      this.style = `width:100%; max-height:100%; min-height:${this.height}`;
      window.addEventListener('resize', () => {
        if (this.myChart !== null && this.myChart !== undefined) {
          this.myChart.resize();
        }
      });
      for (const key in this.milestoneMapChartData) {
        let element = this.milestoneMapChartData[key];
        let countryName = '';
        if (Object.keys(this.mapCountriesNames).includes(key)) {
          countryName = this.mapCountriesNames[key];
        } else {
          let country = key.toLowerCase();
          countryName = country.charAt(0).toUpperCase() + country.slice(1);
        }
        this.data.push({
          name: countryName,
          value: 1,
          activated: element['activated'],
          fsfv: element['activatedFSFV'],
          selectedSites: element['selected'],
        });
      }
    },
    methods: {},
    destroyed() {
      this.myChart = null;
    },
    mounted() {
      echarts.registerMap('world', worldJson);
      this.myChart = echarts.init(this.$refs.milestoneMapChart);
      let option;
      option = {
        grid: {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
        },
        tooltip: {
          trigger: 'item',
          showDelay: 0,
          transitionDuration: 0.2,
          position: ['50%', '50%'],
          formatter: function(params) {
            if (params.data !== undefined) {
              return `<b>${params.name}</b></br>
                 Sites Activated : ${params.data.activated} / ${params.data.selectedSites} <br />
                 Activated Sites with FSFV : ${params.data.fsfv} / ${params.data.activated}<br />`;
            } else {
              return `<b>${params.name}</b></br>`;
            }
          },
        },
        visualMap: {
          min: 0,
          max: 10,
          inRange: {
            color: ['#0095FF'],
          },
          show: false,
        },
        series: [
          {
            name: 'Enrollment',
            type: 'map',
            map: 'world',
            emphasis: {
              label: {
                show: true,
              },
            },
            data: this.data,
          },
        ],
      };
      this.myChart.setOption(option);
    },
  };
</script>

<style></style>
